<template>
  <div class="search-criteria-box">
  <h4 class="tit-search-type is-bgc-red400">耐荷重</h4>
  <!-- <img src="/images/cmn/ico-withstandload.png" class="img-fluid mx-auto" alt="" width="300" height="200"> -->
  <div class="search-radio-set">
    <template v-for="option in options">
    <input type="radio"
    :name="name"
    :id="`label1-${option.id}`"
    :key="`radio1-${option.id}`"
    :value="option.data"
    @change="updateValue(option.data, option.price, option.flag)"
    v-bind:disabled="flags[option.id]==false"
    >
    <label :key="`label1-${option.id}`" :for="`label1-${option.id}`" v-html="option.value"></label>
    </template>
  </div>
</div>
</template>
<script>
export default {
  props: {
    value: {},
    options: { type: Array },
    name: { type: String },
    flags: { type: Object },
  },
  methods: {
    updateValue: function(value, price, flag) {
      this.$emit('WithstandPrice', price);
      this.$emit('WithstandFlag', flag);
      this.$emit("input", value);
    }
  }
}
</script>